import { render, staticRenderFns } from "./CustomerNutrient.vue?vue&type=template&id=6899805a&scoped=true"
import script from "./CustomerNutrient.vue?vue&type=script&lang=js"
export * from "./CustomerNutrient.vue?vue&type=script&lang=js"
import style0 from "./CustomerNutrient.vue?vue&type=style&index=0&id=6899805a&prod&lang=scss&scoped=true"
import style1 from "./CustomerNutrient.vue?vue&type=style&index=1&id=6899805a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6899805a",
  null
  
)

export default component.exports